<template><section><!-- 视频 1：AutumnClass2023-demo1 -->
<video width="800" controls>
  <source src="http://storage.amesholland.xyz/AutumnClass2023-demo1.mp4" type="video/mp4">
  你的浏览器不支持视频播放，请更新浏览器后重试。
</video>
<!-- 视频 2：AutumnClass2023-demo2 -->
<video width="800" controls>
  <source src="http://storage.amesholland.xyz/AutumnClass2023-demo2.mp4" type="video/mp4">
  你的浏览器不支持视频播放，请更新浏览器后重试。
</video>
<!-- 视频 3：AutumnClass2023-demo3 -->
<video width="800" controls>
  <source src="http://storage.amesholland.xyz/AutumnClass2023-demo3.mp4" type="video/mp4">
  你的浏览器不支持视频播放，请更新浏览器后重试。
</video>
<!-- 视频 4：AutumnClass2023-demo4 -->
<video width="800" controls>
  <source src="http://storage.amesholland.xyz/AutumnClass2023-demo4.mp4" type="video/mp4">
  你的浏览器不支持视频播放，请更新浏览器后重试。
</video>
<!-- 视频 5：AutumnClass2023-demo5 -->
<video width="800" controls>
  <source src="http://storage.amesholland.xyz/AutumnClass2023-demo5.mp4" type="video/mp4">
  你的浏览器不支持视频播放，请更新浏览器后重试。
</video>
<!-- 视频 6：AutumnClass2023-demo6 -->
<video width="800" controls>
  <source src="http://storage.amesholland.xyz/AutumnClass2023-demo6.mp4" type="video/mp4">
  你的浏览器不支持视频播放，请更新浏览器后重试。
</video>
<!-- 视频 7：AutumnClass2023-demo7 -->
<video width="800" controls>
  <source src="http://storage.amesholland.xyz/AutumnClass2023-demo7.mp4" type="video/mp4">
  你的浏览器不支持视频播放，请更新浏览器后重试。
</video></section></template><script>export default {components:{}}</script>